import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'viewer-time-display',
  templateUrl: './viewer-time-display.component.html',
  styleUrl: './viewer-time-display.component.scss',
  standalone: false,
})
export class ViewerTimeDisplayComponent {
  @Input() currentTime: number = 0;
  @Input() duration: number = 0;
  @Input() frameRate: number = 25;
  @Input() isFullscreen: boolean = false;

  @Output() displayFormatChange: EventEmitter<'Seconds' | 'Frames'> = new EventEmitter<'Seconds' | 'Frames'>();

  displayFormat: 'Seconds' | 'Frames' = 'Seconds';

  public setFormat(format: 'Seconds' | 'Frames'): void {
    this.displayFormat = format;
    this.displayFormatChange.emit(format);
  }

  get displayTime(): string {
    return this.formatTime(this.currentTime);
  }

  get displayDuration(): string {
    return this.formatTime(this.duration);
  }

  private formatTime(seconds: number): string {
    if (this.displayFormat === 'Frames') {
      return Math.floor(seconds * (this.frameRate || 25)).toString();
    } else {
      const h: number = Math.floor(seconds / 3600);
      const m: number = Math.floor((seconds % 3600) / 60);
      const s: number = Math.floor(seconds % 60);

      const mStr: string = `${m}`.padStart(h > 0 ? 2 : 1, '0');
      const sStr: string = `${s}`.padStart(2, '0');

      if (h > 0) {
        return `${h}:${mStr}:${sStr}`;
      }
      return `${mStr}:${sStr}`;
    }
  }
}
